import { t } from '@lingui/core/macro'
import type { ButtonProps } from 'antd'
import { FaXmark } from 'react-icons/fa6'
import { twMerge } from 'tailwind-merge'
import { ActionButton } from './ActionButton'

export const CancelActionButton = ({
  variant = 'outlined',
  color = 'default',
  icon,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <ActionButton variant={variant} color={color} icon={icon ?? <FaXmark />} className={twMerge(className)} {...props}>
      {children ?? t`Abbrechen`}
    </ActionButton>
  )
}
